import { ReturnShippingLabelAPI } from '../../api/oms/order-details';
// Functions that will encompass the API call will be done here.
// You can check the API response so that all the information is available here, throw an error if not
/**
 * Fetches the Return Shipping Label and will return the Return Label Response
 * @param requestData as IReturnShippingLabelRequest
 * @returns The Response from the API or an Axios Error if empty
 */
export var GetReturnShippingLabelAPI = function (requestData, xAuthGuestToken) {
    return ReturnShippingLabelAPI(requestData, xAuthGuestToken).then(function (response) {
        var _a, _b, _c, _d;
        var printLabelResponse = ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.printReturnShippingLabelService) === null || _b === void 0 ? void 0 : _b.printReturnLabelResponse) ||
            ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.PrintReturnShippingLabelService) === null || _d === void 0 ? void 0 : _d.PrintReturnLabelResponse);
        if (!printLabelResponse) {
            throw new Error('No label found');
        }
        return printLabelResponse;
    });
};
